// firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAnUB-I7W_zrFz9aPNHMVnKFBW0mOqymwU",
  authDomain: "megedigital-2051f.firebaseapp.com",
  projectId: "megedigital-2051f",
  storageBucket: "megedigital-2051f.firebasestorage.app",
  messagingSenderId: "869349495873",
  appId: "1:869349495873:web:8e143ddb22acf42ef162c0",
  measurementId: "G-S4ZHK0KM2F"
};

// אתחול בטוח — לא מאתחל אם כבר קיים
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const db      = getFirestore(app);
export const storage = getStorage(app);

export default app;